<template>
  <div id="chat-container" style="height: 500px;"></div>
</template>

<script>
import Talk from "talkjs";

export default {
  props: {
    account: Object
  },
  mounted() {
    Talk.ready
        .then(() => {
          const user = this.account

          const me = new Talk.User({
              id: user.id,
              name: user.name,
              email: user.email,
              phone: user.phone,
              locale: 'ru-RU',
              role: 'buyer',
              photoUrl: `${process.env.VUE_APP_STORAGE}/${user.avatar}`,
          });

          const session = new Talk.Session({
              appId: "tgD9HNRx",
              me: me
          });

          const inbox = session.createInbox();
          inbox.mount(document.getElementById("chat-container"));
        })
        .catch(error => console.log(error)) 
  }
}
</script>

<style>

</style>